var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPandas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.3936 30.3516H121.894V81.2256H97.3936V30.3516ZM97.3936 134.854H121.894V185.726H97.3936V134.854Z",
    fill: "#130754"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3936 96.0742H121.894V120.076H97.3936V96.0742Z",
    fill: "#FFCA00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0342 72.1738H82.5342V241.278H58.0342V72.1738ZM135.94 176.828H160.44V227.7H135.94V176.828ZM135.94 72.2338H160.44V123.108H135.94V72.2338Z",
    fill: "#130754"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M135.94 137.966H160.44V161.968H135.94V137.966Z",
    fill: "#E70488"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M174.476 17.0996H198.976V186.204H174.476V17.0996Z",
    fill: "#130754"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPandas);
export default __webpack_public_path__ + "static/media/pandas.ca19f0bb296f7210cd586f1a932c2ea0.svg";
export { ForwardRef as ReactComponent };